<template>
	<div id="sidebar">
		<ul style="height: 100%">
			<li>
				<img src="../assets/icons/logos/option-02.svg" alt="" width="70">
			</li>
			<li :class="(getActive == 'resume') ? 'active' : ''">
				<router-link to="/resumen">
                    <i class="icon ico-chart"></i>
					<p>
                        Resumen
                    </p>
				</router-link>
			</li>
			<li :class="(getActive == 'wifi') ? 'active' : ''" v-if=" !(group == 'analista' || group =='marketing') ">
				<router-link to="/contextual">
					<i class="icon ico-router"></i>
                    <p>
                        Portal Cautivo
                    </p>
				</router-link>
			</li>
			<li :class="(getActive == 'infra') ? 'active' : ''" v-if=" (!(group == 'analista' || group =='marketing') && hasPresenceOption() ) ">
				<router-link to="/presencia">
					<i class="icon ico-presence"></i>
					<p>
                        Presencia
                    </p>
				</router-link>
			</li>
			<li :class="(getActive == 'content') ? 'active' : ''" v-if="(group=='manager' || group=='marketing')">
				<router-link to="/contenido">
					<i class="icon ico-sale"></i>
					<p>
                        Contenidos
                    </p>
				</router-link>
			</li>
			<li :class="(getActive == 'clusters') ? 'active' : ''" v-if=" !(group == 'analista' || group =='marketing') ">
				<router-link to="/clusters">
					<i class="icon ico-api"></i>
					<p>
                        Clusters
                    </p>
				</router-link>
			</li>
            <li :class="(getActive == 'downloads') ? 'active' : ''" v-if="(group=='analista')">
				<router-link to="/descargas">
					<i class="icon ico-download"></i>
					<p>
                        Descargas
                    </p>
				</router-link>
			</li>
			<!-- <li class="disabled"><router-link :event="''" to="/contextual"><img src="../assets/icons/beacons.svg" width="24px" />Beacons</router-link></li> -->
		</ul>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data: function(){
        return{
            group: localStorage.getItem('group'),
        }
    },
    name: 'SideBar',
    methods: {
        logout: function(){
            this.$store.dispatch("auth/changeModal", true)
        },
        hasPresenceOption: function(){
            const client = process.env.VUE_APP_CLIENT_NAME
            const presenceClients = ['duoc']
            return presenceClients.includes(client.toLocaleLowerCase())
        }

    },
    computed: {
        ...mapGetters('auth', [
            'getActive'            
        ])
    }
}
</script>

<style lang="sass">
*
    margin: 0
    padding: 0

a
    text-decoration: none

#sidebar
    font-size: 14px
    position: fixed
    width: 120px
    height: 100%
    max-height: 100vh
    left: 0px
    transition: all 500ms linear
    z-index: 500
    @include mobile
        position: fixed
        left: 0
        bottom: 0
        z-index: 9999
        height: fit-content
        width: 100%
        background-color: #000000
    @include mobile-landscape
        position: fixed
        left: 0
        bottom: 0
        z-index: 9999
        height: 64px
        width: 100%
        background-color: #000000
    @include tablet-landscape
        width: 82px
    @include tablet-portrait
        position: fixed
        left: 0
        bottom: 0
        z-index: 9999
        height: 96px
        width: 100%
        background-color: #000000

#sidebar ul
    list-style: none
    min-height: 100vh
    margin: auto
    display: flex
    flex-direction: column
    align-items: flex-start
    @include mobile
        min-height: 48px
        padding-bottom: 34px
        white-space: nowrap
        display: flex
        overflow-x: auto
        overflow-y: hidden
        flex-direction: row
    @include mobile-landscape
        min-height: 64px
        padding-bottom: 34px
        white-space: nowrap
        display: flex
        overflow-x: auto
        overflow-y: hidden
        flex-direction: row
    @include tablet-portrait
        width: 100%
        display: flex
        flex-direction: row


#sidebar ul li
    width: 120px
    font-family: Montserrat
    font-size: 14px
    color: $content-background
    padding: 10px 16px 10px 2px
    text-align: center
    text-decoration: none
    list-style: none
    z-index: 150
    @include mobile
        display: flex
        width: 82px
        padding: 3px
        font-size: 10px
        justify-content: center
    @include mobile-landscape
        width: 82px
    @include tablet-landscape
        width: 90px
    @include tablet-portrait
        width: 100%

#sidebar ul li a
    color: #ffffff
    font-size: 14px
    width: 100%
    height: 100%
    display: block
    @include mobile
        height: 48px
        font-size: 10px
        margin-top: $xs
    @include mobile-landscape
        font-size: 10px
    @include tablet-landscape
        font-size: 12px
    @include tablet-portrait
        font-size: 10px
        height: 35px
        display: block
        margin-top: 8px
    p
        width: 120px
        @include mobile
            width: 80px
        @include mobile-landscape
            width: 80px
        @include tablet-landscape
            width: 90px
        @include tablet-portrait
            width: 100%
    .icon
        font-size: 32px
        @include mobile
            font-size: 24px
        @include mobile-landscape
            font-size: 20px
        @include tablet-landscape
            font-size: 24px
        @include tablet-portrait
            font-size: 22px


#sidebar ul li:first-child
    margin-bottom: 48px
    height: 59px
    @include mobile
        display: none
    @include mobile-landscape
        img
            width: 32px
            height: auto
    @include tablet-portrait
        display: block
        margin-bottom: 24px
        img
            width: 48px
            height: auto

#sidebar ul li.active
    padding-right: 7px
    border-right: 9px solid $secondary
    @include mobile
        padding-right: 3px
        padding-top: 0
        border-right: none
        border-top: 3px solid $secondary
    @include mobile-landscape
        padding-right: 3px
        padding-top: 6px
        border-right: none
        border-top: 3px solid $secondary
    @include tablet-landscape
        border-right: 6px solid $secondary
        padding-right: 10px
    @include tablet-portrait
        border-top: 4px solid $secondary
        padding-right: 8px
        border-right: none

#sidebar ul li.disabled
    opacity: 0.5
    @media (max-width: $phone)
        display: none



#sidebar ul li img
    display: block
    margin-left: auto
    margin-right: auto
    padding: 10px
    @media (max-width: $tablet)
        padding: 0
        margin-top: 5px
        margin-bottom: 3px


#sidebar ul li:hover
    background-color: $secondary
    text-align: center
    text-decoration: none
    list-style: none
    cursor: pointer
    @include mobile
        background: #000
    @include mobile-landscape
        background: #000

#sidebar ul li:first-child:hover
    background-color: transparent
    cursor: default

#sidebar ul li.disabled:hover
    background-color: transparent

#sidebar .logo
    border-radius: 50%
    margin: 0 auto
    display: block

.logo-item
    background-color: white
</style>


